import { z } from "zod";

export const treatmentValidationSchema = z
    .object({
        title: z
            .string()
            .min(2, "treatment_title_must_be_at_least_2_characters")
            .max(200, "treatment_title_must_be_less_than_200_characters"),
        brand: z.string().min(1, "treatment_brand_is_required"),
        description: z
            .string()
            .min(1, "description_is_required")
            .refine((val) => val.trim().length > 0, {
                message: "description_cannot_be_empty",
            }),
        image: z
            .string()
            .min(1, "image_url_is_required")
            .url("please_enter_a_valid_image_url")
            .refine((val) => val.trim().length > 0, {
                message: "image_url_cannot_be_empty",
            }),
        price: z.number().min(0, "price_must_be_positive"),
        discounts: z
            .object({
                actual: z.object({
                    price: z.number().min(0, "discount_price_must_be_positive"),
                }),
            })
            .optional(),
        duration: z.number().min(1, "duration_must_be_at_least_1_minute").int("duration_must_be_a_whole_number"),
        category: z.string().min(1, "treatment_category_is_required"),
        isAppHighlighted: z.boolean().optional().default(false),
    })
    .refine(
        (data) => {
            // If discount price exists, it must be lower than the normal price
            if (data.discounts?.actual?.price !== undefined) {
                return data.discounts.actual.price < data.price;
            }
            return true;
        },
        {
            message: "discount_price_must_be_lower_than_normal_price",
            path: ["discounts", "actual", "price"],
        }
    );
